import { type FC } from "react";

import { Colors } from "@snapchat/snap-design-system";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { type AgeStatsItem } from "../../models";

import { AgeTooltip } from "./AgeTooltip";

const BAR_WIDTH = 37;

export const AgeChart: FC<{ stats: readonly AgeStatsItem<number>[] }> = ({ stats }) => (
    <ResponsiveContainer height={140}>
        <BarChart width={990} height={140} barGap={0} data={[...stats]}>
            <CartesianGrid strokeDasharray="1 6" stroke={Colors.Gray.V300} horizontal={true} vertical={false} />
            <XAxis strokeWidth={0} dataKey="dimensionBreakdown" />
            <YAxis
                tickFormatter={(value) => `${String(value)}%`}
                tick={{ fill: Colors.Gray.V300, fontSize: "11px", fontFamily: "Graphik", fontWeight: 400 }}
                strokeWidth={0}
                interval={0}
            />
            <Bar stackId="women" dataKey="women" fill={Colors.Black.V50} barSize={BAR_WIDTH} />
            <Bar stackId="men" dataKey="men" fill={Colors.Gray.V250} barSize={BAR_WIDTH} />

            <Tooltip cursor={false} content={AgeTooltip} />
        </BarChart>
    </ResponsiveContainer>
);
